import { AnimatedWrapper } from "@/components/DialogWrapper";
import React from "react";
import { useAtom } from "jotai";
import { screenAtom } from "@/store/screens";
import { Video } from "lucide-react";
import AudioButton from "@/components/AudioButton";
import santaVideo from "@/assets/video/vlad-stream.mp4";
import { musicVolumeAtom } from "@/store/musicVolume";

export const Intro: React.FC = () => {
  const [, setScreenState] = useAtom(screenAtom);
  const [musicVolume, setMusicVolume] = useAtom(musicVolumeAtom);

  const handleClick = () => {
    if (musicVolume === 0) {
      setMusicVolume(0.3);
    }
    setScreenState({ currentScreen: "instructions" });
  };

  return (
    <AnimatedWrapper>
      <div className="flex size-full flex-col items-center justify-center">
        <video
          src={santaVideo}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-overlay" />
        <div className="relative z-10 flex flex-col items-center gap-4">
          <div className="flex flex-col items-center gap-2 rounded-md p-4 backdrop-blur-sm">
            <h1 className="mb-4 text-3xl font-bold text-white">
              Vlad Sadovskiy
            </h1>
          </div>
          <AudioButton onClick={handleClick} className="relative z-10">
            <Video className="size-5" />
            Start Conversation
          </AudioButton>
        </div>
      </div>
    </AnimatedWrapper>
  );
};
